module.exports = __webpack_public_path__ + "static/ifsp-203260a7a7ae809b31d96d16b56b9b68.png";